import LivenessCamera from './LivenessCamera';

export default LivenessCamera;
